// TODO ZL-856: replace this custom infrastructure with Firebase Remote Config
import { createFirestoreApi } from '#firebase/firestoreApi'

import { featureFlagsSchema } from './schema'

const api = createFirestoreApi({
  authenticated: false,
  name: 'feature_flags',
  schema: featureFlagsSchema,
})

export const {
  useShowQuery: useShowFeatureFlagsQuery,
  useListQuery: useListFeatureFlagsQuery,
  useUpsertMutation: useUpsertFeatureFlagsMutation,
} = api
